import createAssigner from './_createAssigner.js';
import allKeys from './allKeys.js';

// Fill in a given object with default properties.
export default createAssigner(allKeys, true);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/defaults.js
// module id = 639
// module chunks = 0